import { isValidCNPJ, normalizeCNPJ } from './helpers/cnpj';
import { isDefaultOnlyPayEmail } from './helpers/email';
import { isDefaultOnlyPayPhone } from './helpers/phone';

const locale = {
  locale: 'ptBR',
  dictionary: {
    ptBR: {
      messages: {
        card_format: () => 'O número digitado está incorreto.',
        cep: field => `O campo ${field} possui um formato inválido.`,
        cnpj: field => `O ${field} está inválido.`,
        cnpj_format: field => `O campo ${field} possui um formato inválido.`,
        cpf: field => `O ${field} está inválido.`,
        cpf_format: field => `O campo ${field} possui um formato inválido.`,
        // confirmed: (field, [confirmedField]) => `
        //   Os campos ${field} e ${document.querySelector(`[name="${confirmedField}"]`).dataset.vvAs} devem ser iguais.
        // `,
        confirmed: (field) => `
          Os campos de ${field} devem ser iguais.
        `,
        date_format: field => `O campo ${field} deve estar no formato dd/mm/aaaa.`,
        email: field => `O campo ${field} possui um formato inválido.`,
        not_default_email: field => `O campo ${field} não pode ser um email padrão da OnlyPay.`,
        max: (field, [length]) => `O campo ${field} não deve ter mais que ${length} caracteres.`,
        min: (field, [length]) => `O campo ${field} deve conter pelo menos ${length} caracteres.`,
        money: field => `O ${field} precisa ser R$ 10,00 ou mais.`,
        money_TED: field => `O ${field} precisa ser entre R$ 10,00 e R$ 10.000,00.`,
        password_one_capital_letter: field => `O campo ${field} deve conter pelo menos uma letra maiúscula.`,
        password_one_lower_case_letter: field => `O campo ${field} deve conter pelo menos uma letra minúscula.`,
        password_one_letter: field => `O campo ${field} deve conter pelo menos uma letra.`,
        password_one_number: field => `O campo ${field} deve conter pelo menos um número.`,
        password_special_characters: field => `O campo ${field} deve conter pelo menos dois caracteres especial.`,
        password_forbidden_characters: field => `O campo ${field} não pode conter os caracteres ', ", %, ;, --, / e \\.`,
        phone: field => `O campo ${field} possui um formato inválido.`,
        required: field => `O campo ${field} é obrigatório.`,
      },
    },
  },
};

const validators = {
  card_format(value) {
    // Verifica se o formato está correto (4 grupos de 4 dígitos separados por espaço)
    if (!/^\d{4} \d{4} \d{4} \d{4}$/.test(value)) {
      return false;
    }

    // Remove espaços para verificar se são apenas números
    const cardNumber = value.replace(/\s/g, '');
    if (!/^\d{16}$/.test(cardNumber)) {
      return false;
    }

    return true;
  },
  cep(value) {
    return /^[0-9]{5}-[0-9]{3}$/.test(value);
  },
  cnpj(value) {
    return isValidCNPJ(value);
  },
  cnpj_format(value) {
    if (!value) return false;
    const cnpj = normalizeCNPJ(value);
    return /^[A-Z0-9]{12}\d{2}$/.test(cnpj);
  },
  confirmed(value, field) {
    return value === document.querySelector(`[name="${field}"]`).value;
  },
  cpf(value) {
    const cpf = value.replace(/\D/g, '');
    if (cpf.toString().length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }
    let result = true;
    [9, 10].forEach((j) => {
      let sum = 0;
      let r;
      cpf.split(/(?=)/).splice(0, j).forEach((e, i) => {
        sum += parseInt(e, 10) * ((j + 2) - (i + 1));
      });
      r = sum % 11;
      r = (r < 2) ? 0 : 11 - r;
      if (r !== parseInt(cpf.substring(j, j + 1), 10)) {
        result = false;
      }
    });
    return result;
  },
  cpf_format(value) {
    return /^\d{3}\.\d{3}.\d{3}-\d{2}$/.test(value);
  },
  date_format(value) {
    return /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/.test(value);
  },
  not_default_email(value) {
    return !isDefaultOnlyPayEmail(value);
  },
  money(value) {
    return value >= 10;
  },
  moneyTED(value) {
    return (value < 10 && value <= 10000);
  },
  password_one_capital_letter(value) {
    return /[A-Z]+/.test(value);
  },
  password_one_lower_case_letter(value) {
    return /[a-z]+/.test(value);
  },
  password_one_letter(value) {
    return /[\w]+/.test(value);
  },
  password_one_number(value) {
    return /\d+/.test(value);
  },
  password_special_characters(value) {
    // min 2 special characters
    return /(.*?[\W_].*?){2,}/.test(value);
    // return /[\`\~\!\@\#\$\%\^\&\*\(\)\-\_\+\=\[\]\{\}\\\|\;\:\'\"\,\.\<\>\/\?]{2,}/.test(value);
  },
  password_forbidden_characters(value) {
    if (!value) return true;
    return !/['"%/;\\]|--/.test(value);
  },
  phone(value) {
    const phone = value.replace(/\D/g, '');
    if (isDefaultOnlyPayPhone(phone)) {
      return false;
    }
    // Remove código do país se presente (55)
    const cleanPhone = phone.replace(/^55/, '');
    // Garante que começa com 0 (DDD)
    if (!cleanPhone.startsWith('0')) {
      return false;
    }
    // Remove o 0 inicial do DDD para análise
    const withoutCountry = cleanPhone.substring(1);
    // DDD deve ter 2 dígitos
    if (withoutCountry.length < 2) {
      return false;
    }
    const ddd = withoutCountry.substring(0, 2);
    const number = withoutCountry.substring(2);

    // Verifica se DDD é válido (11-99, não pode ser 00)
    if (!/^[1-9][1-9]$/.test(ddd)) {
      return false;
    }

    // Se começar com 9, é celular (deve ter 9 dígitos)
    if (number.startsWith('9')) {
      if (number.length !== 9) {
        return false;
      }
      // Valida formato de celular: 9 seguido de 8 dígitos
      if (!/^9\d{8}$/.test(number)) {
        return false;
      }
    } else {
      // Se não começar com 9, é fixo (deve ter 8 dígitos)
      if (number.length !== 8) {
        return false;
      }
      // Valida formato de fixo: 8 dígitos
      if (!/^\d{8}$/.test(number)) {
        return false;
      }
    }

    // Rejeita números com muitos dígitos repetidos
    return !(/(\d)\1{6,}/.test(phone));
  },
  // phone(value) {
  //   const phone = value.replace(/\D/g, '');
  //   if (/^(\+?55\s?)?0([1-9]{2}|[2-9]{1}[1-9]{1}|\([1-9]{2}\)|\([2-9]{1}[1-9]{1}\))\s?(9)\s?(\d{4})-?(\d{4})$/g.test(phone)) {
  //     return !(/0000000|1111111|2222222|3333333|4444444|5555555|6666666|7777777|8888888|9999999/.test(phone));
  //   } return false;
  // },
};

const PASSWORD_FORBIDDEN_CHARACTERS_MESSAGE = 'Não são permitidos os caracteres \', ", %, ;, --, / e \\.';

function meetsPasswordStrength(password, confirmation) {
  return !!password
    && password === confirmation
    && /[\w]+/.test(password)
    && /\d+/.test(password)
    && /(.*?[\W_].*?){2,}/.test(password)
    && /[a-z]+/.test(password)
    && /[A-Z]+/.test(password)
    && password.length >= 10;
}

function isPasswordValid(password, confirmation) {
  return meetsPasswordStrength(password, confirmation)
    && validators.password_forbidden_characters(password);
}

function isPasswordRejectedOnlyForForbiddenCharacters(password, confirmation) {
  return meetsPasswordStrength(password, confirmation)
    && !validators.password_forbidden_characters(password);
}

export {
  locale,
  validators,
  PASSWORD_FORBIDDEN_CHARACTERS_MESSAGE,
  isPasswordValid,
  isPasswordRejectedOnlyForForbiddenCharacters,
};
